import React, { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Plus, X } from 'lucide-react';
import { PromptDialog } from '@/components/PromptDialog';

export function DataSetsPanel({ dataSets, setDataSets, rowDims }) {
  const [promptOpen, setPromptOpen] = useState(false);

  const handleAdd = (name) => {
    setDataSets(prev => [...prev, { name, field: rowDims[0] || '', values: [], type: 'manual' }]);
  };

  const removeSet = (target) => {
    setDataSets(prev => prev.filter(s => s !== target));
  };

  return (
    <div className="p-3 border-b border-border/30">
      <div className="flex items-center justify-between mb-1">
        <p className="text-[9px] text-muted-foreground uppercase tracking-wider font-semibold">Sets</p>
        <button onClick={() => setPromptOpen(true)} className="text-primary" data-testid="dataset-add-btn"><Plus className="w-3 h-3" /></button>
      </div>
      {dataSets.map((s, si) => (
        <div key={`set-${si}-${s.name}`} className="flex items-center gap-1 mb-1 group/set">
          <Badge variant="outline" className="text-[8px] flex-1">{s.name} ({s.values?.length || 0} members)</Badge>
          <button onClick={() => removeSet(s)} className="text-muted-foreground/30 hover:text-destructive opacity-0 group-hover/set:opacity-100">
            <X className="w-2.5 h-2.5" />
          </button>
        </div>
      ))}
      {dataSets.length === 0 && <p className="text-[8px] text-muted-foreground/30 italic">No sets defined</p>}

      <PromptDialog
        open={promptOpen} onOpenChange={setPromptOpen}
        title="New Set"
        label="Set name"
        placeholder="e.g. Top 5 Lines of Business"
        confirmLabel="Create Set"
        onConfirm={handleAdd}
        testId="dataset-prompt"
      />
    </div>
  );
}
